import { useTheme } from "@emotion/react";
import React from "react";
import AsyncSelect from "react-select/async";
import AsyncCreatableSelect from "react-select/async-creatable";

export const EOCAsyncSelect = ({
  cy = "",
  updateF,
  value,
  loadOptions,
  clearAble = true,
  defaultOptions = false,
  isMulti = false,
  listHeight = 150,
  cache = true,
  isSearchable = true,
  isCreatable = false,
  getOptionLabel = (opt) => opt.label,
}) => {
  const theme = useTheme();
  const optionStyles = {
    control: (styles, { isFocused }) => {
      return {
        ...styles,
        boxShadow: "none",
        backgroundColor: value ? "#fff" : "#f5f5f5",
        borderRadius: "0px",
        border: "none",
        borderTopRightRadius: "4px",
        borderTopLeftRadius: "4px",
        borderBottom: isFocused ? "solid " : "solid 1px",
        borderColor: theme.palette.primary.main,
        ":hover": {
          ...styles[":hover"],
          background: "#ccca",
          borderBottom: isFocused ? "solid" : "solid 1px",
          borderColor: theme.palette.secondary.main,
        },
      };
    },
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      var extraStyles = data.__isNew__
        ? {
            fontWeight: "Bolder",
            color: theme.palette.error.main,
            border: "solid 1px pink",
          }
        : {};
      return {
        ...styles,
        ...extraStyles,
        background: isFocused
          ? theme.palette.primary.light
          : isSelected
          ? theme.palette.primary.main
          : data.type && data.type === "group"
          ? theme.palette.success.main
          : null,
        ":active": { backgroundColor: theme.palette.secondary.light },
      };
    },
    placeholder: (styles) => ({ ...styles }),
    multiValueRemove: (styles, { data }) => {
      if (data.isFixed) return { ...styles, display: "none" };
      else
        return {
          ...styles,
          borderRadius: "0px",
          borderTopRightRadius: "8px",
          borderBottomRightRadius: "8px",
        };
    },
    multiValueLabel: (styles) => ({
      ...styles,
      color: "#fff",
      fontWeight: 400,
    }),
    multiValue: (styles, { data }) => {
      if (data.isFixed)
        return {
          ...styles,
          background:
            data.type && data.type === "group"
              ? theme.palette.success.dark
              : theme.palette.primary.main,
          borderRadius: "10px",
          padding: "0 2px 0 0",
        };
      return {
        ...styles,
        background:
          data.type && data.type === "group"
            ? theme.palette.success.light
            : theme.palette.secondary.main,
        borderRadius: "10px",
      };
    },
    loadingIndicator: (styles) => ({
      ...styles,
      color: theme.palette.secondary.main,
    }),
    menu: (styles) => ({
      ...styles,
      zIndex: 9999,
    }),
    menuList: (styles) => ({
      ...styles,
      maxHeight: listHeight + "px",
      overflow: "auto",
    }),
  };
  if (isCreatable) {
    if (isMulti) {
      return (
        <span data-cy={"AsyncSelect_" + cy.replace(/ /g, "_")}>
          <AsyncCreatableSelect
            createOptionPosition="first"
            isSearchable={isSearchable}
            isMulti
            value={value !== null ? value.slice() : null}
            onChange={updateF}
            loadOptions={loadOptions}
            backspaceRemovesValue
            isClearable={clearAble}
            styles={optionStyles}
            cacheOptions={cache}
            defaultOptions={defaultOptions}
            getOptionLabel={getOptionLabel}
            menuPosition="fixed"
            placeholder="Type to Select..."
          />
        </span>
      );
    } else {
      return (
        <span data-cy={"AsyncSelect_" + cy.replace(/ /g, "_")}>
          <AsyncCreatableSelect
            isSearchable={isSearchable}
            value={value}
            onChange={updateF}
            loadOptions={loadOptions}
            backspaceRemovesValue
            isClearable={clearAble}
            styles={optionStyles}
            cacheOptions={cache}
            defaultOptions={defaultOptions}
            getOptionLabel={getOptionLabel}
            menuPosition="fixed"
            placeholder="Type to Select..."
          />
        </span>
      );
    }
  } else {
    if (isMulti) {
      return (
        <span data-cy={"AsyncSelect_" + cy.replace(/ /g, "_")}>
          <AsyncSelect
            isSearchable={isSearchable}
            isMulti
            value={value !== null ? value.slice() : null}
            onChange={updateF}
            loadOptions={loadOptions}
            backspaceRemovesValue
            isClearable={clearAble}
            styles={optionStyles}
            cacheOptions={cache}
            defaultOptions={defaultOptions}
            getOptionLabel={getOptionLabel}
            menuPosition="fixed"
            placeholder="Type to Select..."
          />
        </span>
      );
    } else {
      return (
        <span data-cy={"AsyncSelect_" + cy.replace(/ /g, "_")}>
          <AsyncSelect
            isSearchable={isSearchable}
            value={value}
            onChange={updateF}
            loadOptions={loadOptions}
            backspaceRemovesValue
            isClearable={clearAble}
            styles={optionStyles}
            cacheOptions={cache}
            defaultOptions={defaultOptions}
            getOptionLabel={getOptionLabel}
            menuPosition="fixed"
            placeholder="Type to Select..."
          />
        </span>
      );
    }
  }
};
